export default __webpack_public_path__ + "static/media/Express-Property.87c61e67.png";